<template>
  <div class="restore-password">
    <AuthBody title="Восстановление пароля">
      <form @submit.prevent="validateAndSubmit">
        <section class="group">
          <label for="email">E-mail</label>
          <input id="email"
                 class="form-control--flat"
                 type="text"
                 v-model="email"
                 name="email"
                 data-vv-as="E-mail"
                 v-validate="'email'"
                 :readonly="loading"
                 required/>
          <p v-show="errors.has('email')"
             class="restore-password__error">
            {{ errors.first('email') }}
          </p>
        </section>

        <div v-if="isIncorrectParams" class="restore-password__error">
          Указанный E-mail адрес не зарегистрирован
        </div>

        <section class="btn-group">
          <button class="button btn-group__submit-btn">
            Восстановить пароль
            <SpinnerRing v-if="loading" color="#fff" class="btn-group__loader" />
          </button>
        </section>
      </form>
    </AuthBody>
  </div>
</template>

<script>
import AuthBody from '@/views/Authorize/components/AuthBody.vue';
import SpinnerRing from '@/components/Spinner/SpinnerRing.vue';
import { restorePassword } from '@/api/auth';
import { notyf } from '@/api/index';


export default {
  components: {
    AuthBody,
    SpinnerRing,
  },

  data() {
    return {
      loading: false,
      isIncorrectParams: false,

      email: '',
    };
  },

  methods: {
    async validateAndSubmit() {
      const isValid = await this.$validator.validate();

      if (isValid) {
        this.loading = true;
        this.isIncorrectParams = false;

        try {
          await restorePassword(this.email);

          notyf.confirm('На указанный E-mail отправлено письмо со ссылкой для восстановления пароля');
        } catch (error) {
          this.isIncorrectParams = true;
        }

        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.restore-password {
  label {
    text-align: center;
    font-size: 18px;
  }

  &__error {
    color: #FC402F;
    font-size: 12px;
    margin-bottom: 14px;
  }
}
</style>
